import { render, staticRenderFns } from "./MagycorpSaDocumentL.vue?vue&type=template&id=1ba3c5f4&scoped=true&"
import script from "./MagycorpSaDocumentL.vue?vue&type=script&lang=js&"
export * from "./MagycorpSaDocumentL.vue?vue&type=script&lang=js&"
import style0 from "./MagycorpSaDocumentL.vue?vue&type=style&index=0&id=1ba3c5f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3c5f4",
  null
  
)

export default component.exports